import { render, staticRenderFns } from "./newperk.vue?vue&type=template&id=e29c2fee&scoped=true"
import script from "./newperk.vue?vue&type=script&lang=js"
export * from "./newperk.vue?vue&type=script&lang=js"
import style0 from "./newperk.vue?vue&type=style&index=0&id=e29c2fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29c2fee",
  null
  
)

export default component.exports